export default __webpack_public_path__ + "static/media/table.c7b3c679.jpg";